import { render } from "./HeaderBarItem.vue?vue&type=template&id=1af1f5f8"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./HeaderBarItem.vue?vue&type=style&index=0&id=1af1f5f8&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script